// src/lib/noteFormat.ts
import {
  NOTE_FORMATS,
  type NoteFormatId,
  type NoteFormatDefinition,
} from "@/shared/lib/noteFormats";

export function resolveNoteFormat(
  profilePreferred: string | null | undefined,
  verticalDefault: NoteFormatId | undefined,
): NoteFormatDefinition {
  if (profilePreferred && profilePreferred in NOTE_FORMATS) {
    return NOTE_FORMATS[profilePreferred as NoteFormatId];
  }
  if (verticalDefault && verticalDefault in NOTE_FORMATS) {
    return NOTE_FORMATS[verticalDefault];
  }
  return NOTE_FORMATS.freeform;
}
